import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {PoStorageService} from '@po-ui/ng-storage';
import {Token} from '../interface/usuario';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private router: Router, private poStorageService: PoStorageService, private authService: AuthService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes(environment.urlApiProtheus)) {
      const tokenJson = localStorage.getItem('token');
      if (tokenJson) {
        const token = JSON.parse(tokenJson) as Token;
        const diffTime = Math.abs(token.last_token_refresh - new Date().getTime() / 1000);
        if (diffTime > token.expires_in) {
          localStorage.clear();
          this.poStorageService.clear();
          this.router.navigateByUrl('/login');
          return next.handle(request);
        }
        if (diffTime > token.expires_in - 1800 && !request.url.includes('oauth2')) {
          this.authService.refreshToken(token.refresh_token).subscribe({
            next: (newToken: Token) => {
              localStorage.setItem('token', JSON.stringify({...newToken, last_token_refresh: new Date().getTime() / 1000}));
            }, error: (e) => {
              console.log(e)
              localStorage.clear();
              this.poStorageService.clear();
              this.router.navigateByUrl('/login');
            }
          });
        }
        request = request.clone({
          setHeaders: {
            'X-PO-Screen-Lock': 'true',
            Authorization: `${token.token_type} ${token.access_token}`,
            tenantid: localStorage.getItem('tenantid') || '',
            CUSRID: localStorage.getItem('CUSRID') || '',
          }
        });
      }
    }

    return next.handle(request);
  }
}
